import { render, staticRenderFns } from "./buyout-grants.vue?vue&type=template&id=67473c34&"
import script from "./buyout-grants.vue?vue&type=script&lang=js&"
export * from "./buyout-grants.vue?vue&type=script&lang=js&"
import style0 from "./buyout-grants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports